import { GlobalThisType } from "../types/ContentTypes";

export const useGlobalSettings = () => {
    return globalThis as unknown as GlobalThisType;
};
